// Vuex object store module
import icon from './icon'

let objectSocket = ''

const state = {
  objects  : [],
  $objects : {
    id_000 : [],
    id_001 : []
  }
}

const getters = {
  objects: state => state.objects
}

// socket mutations
const socketsOfMutation = {
  SOCKET_object_connect (state, socket) {
    objectSocket = socket
  },
  SOCKET_object_joinRoom (state, data) {
    state.objects = data
  },
  SOCKET_object_addNewObject (state, payload) {
    state.objects.push(payload)
  },
  SOCKET_object_removeObject (state, data) {
    state.objects.some((obj, index) => {
      if (obj.id === data) {
        state.objects.splice(index, 1)
      }
    })
  },
  SOCKET_object_clearObjects (state, data) {
    state.objects = []
  },
  SOCKET_object_updateObjectProperty (state, data) {
    state.objects.some(obj => {
      if (obj.id === data.id) {
        Object.assign(obj, data)
        return true
      }
    })
  }
}

// local mutations
const mutations = {
  updateObjectProperty (state, data) {
    state.objects.some(obj => {
      if (obj.id === data.id) {
        Object.assign(obj, data)
        return true
      }
    })
  },
  ...socketsOfMutation
}

const actions = {
  addNewObject ({commit}, objectData) {
    // objectSocket.emit('addNewObject', objectData)
    commit('SOCKET_object_addNewObject', Object.assign({}, objectData));
  },
  clearObjects ({commit}) {
    commit('SOCKET_object_clearObjects')
  },
  removeObject ({commit}, id) {
    commit('SOCKET_object_removeObject', id)
    // objectSocket.emit('removeObject', id)
  },
  // updata
  updateObjectProperty ({commit}, data) {
    commit('updateObjectProperty', data)
    // objectSocket.emit('updateObjectProperty', data)
  },
  updateObjectProperty_local ({commit}, data) {
    commit('updateObjectProperty', data)
  }
}

export default {
  namespaced : true,
  state,
  getters,
  actions,
  mutations,
  modules    : {
    icon
  }
}



// WEBPACK FOOTER //
// ./src/components/object/store/index.js